import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Button, Message, Select, Typography } from "@arco-design/web-react";
import { IconEmail } from "@arco-design/web-react/icon";
import { FetchApi, PostApi } from "../Api/AuthenticatedApi";

const { Text } = Typography;

// What the server said it sent (subscriptions.SignupEmailKind).
const KIND_LABEL = {
    confirmation: "the confirmation email",
    incentive: "the download email",
    campaign_email: "the campaign email",
};

// "Resend signup email" for a contact who didn't get it or deleted it. The
// server picks what to send from where they are: the confirmation if they
// haven't confirmed, the download email if they have and the reward goes by
// email, otherwise the campaign email. Rate limited server-side.
export default function ResendSignupEmail({ contactId }) {
    const { getAccessTokenSilently } = useAuth0();
    const [campaigns, setCampaigns] = React.useState([]);
    const [campaignId, setCampaignId] = React.useState("");
    const [sending, setSending] = React.useState(false);

    React.useEffect(() => {
        FetchApi(getAccessTokenSilently, "/api/campaigns/?" + new URLSearchParams({ page: 0, count: 100 }),
            (data) => setCampaigns((data && data.campaigns) || []), () => {}, () => {});
    }, [getAccessTokenSilently]);

    const resend = () => {
        setSending(true);
        PostApi(getAccessTokenSilently, `/api/contacts/${contactId}/resend-signup-email`,
            (res) => {
                setSending(false);
                Message.success(`Sent ${KIND_LABEL[res.kind] || "the signup email"} for "${res.campaign_name}".`);
            },
            () => setSending(false),
            (err) => {
                setSending(false);
                Message.error((err && err.message) || "Couldn't resend the signup email");
            },
            { campaign_id: campaignId || "" });
    };

    return (
        <div style={{ marginTop: 16, padding: "10px 12px", border: "1px solid var(--color-border-2)", borderRadius: 6 }}>
            <div style={{ fontWeight: 500, marginBottom: 4 }}>Signup email</div>
            <Text type="secondary" style={{ fontSize: 12, display: "block", marginBottom: 8 }}>
                Didn't get it, or deleted it? Resend it: they'll get the confirmation if they haven't confirmed yet,
                otherwise their download (or the campaign email again).
            </Text>
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                <Select
                    allowClear
                    placeholder="Their most recent campaign"
                    style={{ flex: "1 1 200px" }}
                    value={campaignId || undefined}
                    onChange={(v) => setCampaignId(v || "")}
                    options={campaigns.map((c) => ({ label: c.name, value: c.id }))}
                />
                <Button icon={<IconEmail />} loading={sending} onClick={resend}>Resend signup email</Button>
            </div>
        </div>
    );
}
